export default {
	title: '终端管理',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功'
	},
	form: {
		projNo: '所属项目',
		transferProtocol: '通讯协议',
		number: '终端编号',
		typeId: '终端类型',
		placeholder: {
			projNo: '请选择所属项目',
			transferProtocol: '请选择通讯协议',
			number: '请输入终端编号',
			typeId: '请选择终端类型'
		}
	},
	table: {
		number: '终端编号',
		projNo: '项目编号',
		orgId: '机构',
		model: '型号',
		upMode: '上行模式',
		downMode: '下行模式',
		typeId: '终端类型',
		transferProtocol: '通讯协议',
		ip: 'IP 地址',
		maker: '厂家',
		createTime: '创建时间'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		projNo: '所属项目',
		orgId: '机构',
		typeId: '终端类型',
		maker: '厂家',
		transferProtocol: '通讯协议',
		model: '型号',
		number: '终端编号',
		ip: 'IP 地址',
		upMode: '上行模式',
		downMode: '下行模式',
		attachmentList: '网络链路图信息',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			projNo: '请选择所属项目',
			orgId: '请选择机构',
			typeId: '请选择终端类型',
			maker: '请输入厂家',
			transferProtocol: '请选择通讯协议',
			model: '请输入型号',
			number: '请输入终端编号',
			ip: '请输入 IP 地址',
			upMode: '请选择上行模式',
			downMode: '请选择下行模式'
		}
	}
}
